import React, { useState, useEffect, useMemo } from "react";
import {
  EditContainer,
  EditContainerDiv1,
  EditContainerDiv2,
  Button,
} from "./Editquestion.style";
import DropDown from "../../DropDown/DropDown";
import AttachFileOutlinedIcon from "@material-ui/icons/AttachFileOutlined";
import TrashOultinedIcon from "@material-ui/icons/CloseTwoTone";
import EditQuestionInput from "./EditQuestionInput";

function ImageField(props) {
  return (
    <>
      {props.isImage ? (
        <div onClick={props.removeImage}>
          <TrashOultinedIcon />
        </div>
      ) : (
        <label
          style={{
            fontSize: "2rem",
            cursor: "pointer",
            marginleft: "10px",
          }}
          for={props.id}
        >
          <AttachFileOutlinedIcon />
        </label>
      )}
      {!props.isImage ? (
        <>
          <span>{props.filename}</span>
          <input
            onChange={props.addImage}
            id={props.id}
            style={{ display: "none" }}
            type="file"
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
}

function Editquestion(props) {
  const [options, setOptions] = useState([...props.options]);
  const [question, setQuestion] = useState(props.question);
  const [assertion, setAssertion] = useState(
    props.description?.assertion || "",
  );
  const [reason, setReason] = useState(props.description?.reasoning || "");
  const [formData, setFormData] = useState({
    cognitive: props.cognitive,
    difficulty: props.difficulty,
  });
  const [markedDeleted, setMarkedDeleted] = useState([]);
  const images = useMemo(() => {
    return { ...props.images };
  }, [props.images]);

  const [loading, setLoading] = useState(true);
  const [correctAnswer, setCorrectAnswer] = useState();
  const [updatedImages, setUpdatedImages] = useState({});
  const handleImages = (dt, id) => {
    setUpdatedImages({ ...updatedImages, [id]: dt.target.files[0] });
  };

  const removeImage = (id) => {
    markedDeleted.push(id);
    setMarkedDeleted([...markedDeleted]);
  };

  useEffect(() => {
    if (props.correctAnswers) {
      if (
        props.questionType === "mcq" ||
        props.questionType === "correctstatement"
      ) {
        setCorrectAnswer(
          parseInt(
            props?.correctAnswers[props.questionType]?.split("")?.at(-1) - 1,
          ),
        );
        setLoading(false);
      } else if (props.questionType === "mmcq") {
        setCorrectAnswer(
          props.correctAnswers[props.questionType]?.map((item) => {
            return parseInt(item.split("").at(-1)) - 1;
          }),
        );
        setLoading(false);
      } else {
        setCorrectAnswer(props.correctAnswers[props.questionType]);
        setLoading(false);
      }
    }
  }, [props]);
  console.log(correctAnswer);
  // console.log(correctAnswer);
  const handleCorrectAnswer = (id, type) => {
    if (type === "mmcq") {
      if (correctAnswer.indexOf(id) !== -1) {
        setCorrectAnswer(correctAnswer.filter((item, idx) => idx !== id));
      } else {
        setCorrectAnswer([...correctAnswer, id]);
      }
    } else if (["mcq", "correctstatement"].includes(type)) {
      setCorrectAnswer(id);
    } else if (["assertion-reasoning"].includes(type)) {
      setCorrectAnswer({ ...correctAnswer, option: id });
    }
  };

  const { questionType } = props;
  const Update = async () => {
    let form = new FormData();
    const { cognitive, difficulty } = formData;
    let anser;
    if (props.questionType === "mmcq") {
      anser = {
        [questionType]: correctAnswer.map((item, idx) => `op${item + 1}`),
      };
    } else if (["mcq", "correctstatement"].includes(questionType)) {
      anser = { [questionType]: `op${correctAnswer + 1}` };
    } else if (
      ["fillup", "oneword", "descriptive", "assertion-reasoning"].includes(
        questionType,
      )
    ) {
      anser = { [questionType]: correctAnswer };
    }

    let visibilityStatus = "publicForAll";
    form.append(
      "question",
      JSON.stringify({
        question,
        questionType,
        description: {
          assertion,
          reasoning: reason,
        },
        options,
        cognitive,
        difficulty,
        correctAnswers: anser,
        visibilityStatus,
        images,
      }),
    );
    form.append("markedDeleted", JSON.stringify(markedDeleted));
    for (let [key, value] of Object.entries(updatedImages)) {
      form.append([key], value);
    }
    props.handleUpdate(props._id, form, () => props.close("update"));
  };
  const handleOnChange = (value, id, type) => {
    if (["mcq", "correctstatement", "mmcq"].includes(type)) {
      setOptions(
        options.map((item, idx) => (id === idx ? { ...item, value } : item)),
      );
    } else if (["fillup", "oneword", "descriptive"].includes(type)) {
      setCorrectAnswer(
        correctAnswer.map((item, idx) =>
          id === idx ? { ...item, answer: value } : item,
        ),
      );
    } else if (type === "assertion-reasoning") {
      if (id === "op5") {
        setCorrectAnswer({ ...correctAnswer, explanation: value });
      } else {
        setOptions(
          options.map((item, idx) => (id === idx ? { ...item, value } : item)),
        );
      }
    }
  };

  return (
    <EditContainer>
      <EditContainerDiv1>
        {props.questionType === "assertion-reasoning" ? (
          <>
            <EditQuestionInput
              id="assertion"
              value={assertion}
              onChange={setAssertion}
              placeholder={"Write Assertion"}
              isImage={images.assertImg && !markedDeleted.includes("assertImg")}
              imageName={updatedImages?.assertImg?.name}
              addImage={(e) => {
                setUpdatedImages({
                  ...updatedImages,
                  assertImg: e.target.files[0],
                });
              }}
              removeImage={() => removeImage("assertImg")}
            />
            <EditQuestionInput
              id="reasoning"
              value={reason}
              onChange={setReason}
              placeholder={"Write Reason"}
              isImage={images.reasonImg && !markedDeleted.includes("reasonImg")}
              imageName={updatedImages?.reasonImg?.name}
              addImage={(e) => {
                setUpdatedImages({
                  ...updatedImages,
                  reasonImg: e.target.files[0],
                });
              }}
              removeImage={() => removeImage("reasonImg")}
            />
          </>
        ) : (
          <EditQuestionInput
            id="question"
            value={question}
            onChange={setQuestion}
            placeholder={"Enter Question"}
            isImage={
              images.questionImg && !markedDeleted.includes("questionImg")
            }
            imageName={updatedImages?.questionImg?.name}
            addImage={(e) => {
              setUpdatedImages({
                ...updatedImages,
                questionImg: e.target.files[0],
              });
            }}
            removeImage={() => removeImage("questionImg")}
          />
        )}
        <div className="options">
          {!loading &&
            options.map((item, id) => {
              if (["mcq", "correctstatement"].includes(props.questionType)) {
                return (
                  <div style={{ display: "flex", width: "100%", flex: 1 }}>
                    <div
                      onClick={() =>
                        handleCorrectAnswer(id, props.questionType)
                      }
                      style={{
                        width: "18px",
                        cursor: "pointer",
                        backgroundColor: `${
                          (correctAnswer.option || correctAnswer) === id
                            ? "#0f93a8"
                            : "transparent"
                        }`,
                        margin: "auto 10px auto 0",
                        border: "2px solid #0f93a8",
                        height: "18px",
                      }}
                    ></div>
                    <EditQuestionInput
                      id={`answer${item.optionId}`}
                      onChange={(value) =>
                        handleOnChange(value, id, props.questionType)
                      }
                      value={item.value}
                      isImage={
                        images[item.optionId] &&
                        !markedDeleted.includes(item.optionId)
                      }
                      imageName={updatedImages?.[item?.optionId]?.name || ""}
                      addImage={(e) => handleImages(e, item.optionId)}
                      removeImage={() => removeImage(item?.optionId || "")}
                    />
                  </div>
                );
              }
              if (["assertion-reasoning"].includes(props.questionType)) {
                return (
                  <div style={{ display: "flex", width: "100%", flex: 1 }}>
                    <div
                      onClick={() =>
                        handleCorrectAnswer(item.optionId, props.questionType)
                      }
                      style={{
                        width: "18px",
                        cursor: "pointer",
                        backgroundColor: `${
                          correctAnswer.option === item.optionId
                            ? "#0f93a8"
                            : "transparent"
                        }`,
                        margin: "auto 10px auto 0",
                        border: "2px solid #0f93a8",
                        height: "18px",
                      }}
                    ></div>
                    <EditQuestionInput
                      id={`answer${item.optionId}`}
                      onChange={(value) =>
                        handleOnChange(value, id, props.questionType)
                      }
                      value={item.value}
                      isImage={
                        images[item.optionId] &&
                        !markedDeleted.includes(item.optionId)
                      }
                      imageName={updatedImages?.[item?.optionId]?.name || ""}
                      addImage={(e) => handleImages(e, item.optionId)}
                      removeImage={() => removeImage(item?.optionId || "")}
                    />
                  </div>
                );
              } else if (props.questionType === "mmcq") {
                return (
                  <div style={{ display: "flex" }}>
                    <div
                      onClick={() => handleCorrectAnswer(id, "mmcq")}
                      style={{
                        width: "18px",
                        cursor: "pointer",
                        backgroundColor: `${
                          correctAnswer?.indexOf(id) !== -1
                            ? "#0f93a8"
                            : "transparent"
                        }`,
                        margin: "auto 10px auto 0",
                        border: "2px solid #0f93a8",
                        height: "18px",
                      }}
                    ></div>
                    <EditQuestionInput
                      id={`answer${item.optionId}`}
                      onChange={(value) => handleOnChange(value, id, "mmcq")}
                      value={item.value}
                      isImage={
                        images[item.optionId] &&
                        !markedDeleted.includes(item.optionId)
                      }
                      imageName={updatedImages?.[item?.optionId]?.name || ""}
                      addImage={(e) => handleImages(e, item.optionId)}
                      removeImage={() => removeImage(item?.optionId || "")}
                    />
                  </div>
                );
              } else {
                return (
                  <EditQuestionInput
                    onChange={(value) => handleOnChange(value, id, "fillup")}
                    value={correctAnswer[id].answer}
                    id={`answer${item.optionId}`}
                    isImage={
                      images[item.optionId] &&
                      !markedDeleted.includes(item.optionId)
                    }
                    imageName={updatedImages?.[item?.optionId]?.name || ""}
                    addImage={(e) => handleImages(e, item.optionId)}
                    removeImage={() => removeImage(item?.optionId || "")}
                  />
                );
              }
            })}
        </div>
        {props.questionType === "assertion-reasoning" && (
          <EditQuestionInput
            onChange={(value) =>
              handleOnChange(value, "op5", "assertion-reasoning")
            }
            value={correctAnswer?.explanation || ""}
            id={`op5`}
            isImage={false}
            imageName={""}
          />
        )}
        <div className="buttonWrapper">
          <Button onClick={() => Update()}>Update</Button>
          <Button onClick={() => props.close("cancel")}>Cancel</Button>
        </div>
      </EditContainerDiv1>

      <EditContainerDiv2>
        <div style={{ margin: "10px  20px" }}>
          <DropDown
            options={["knowledge", "analysis", "understanding", "application"]}
            name="cognitive"
            formData={formData}
            setFormData={setFormData}
            placeholder="Cognitive"
          />
        </div>
        {props.assessmentType !== "competency" ? (
          <div style={{ margin: "10px 20px" }}>
            <DropDown
              options={["easy", "intermediate", "hard"]}
              name="difficulty"
              formData={formData}
              setFormData={setFormData}
              placeholder="Difficulty"
            />
          </div>
        ) : null}
      </EditContainerDiv2>
    </EditContainer>
  );
}

export default Editquestion;
